export default "__VITE_ASSET__BCkIgCgW__"